import { useNavigate } from "react-router-dom";
import CancelButton from "../components/cancelButton/CancelButton";

const CalculationCancelButton = () => {
  const navigate = useNavigate();
  const navigateToCalculationsList = () => navigate("/calculations");
  return <CancelButton onClick={navigateToCalculationsList} />;
};

export default CalculationCancelButton;
